"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var DEFAULT_MAP_STYLES = [{
  featureType: 'administrative.land_parcel',
  stylers: [{
    visibility: 'off'
  }]
}, {
  featureType: 'poi',
  elementType: 'labels.text',
  stylers: [{
    visibility: 'off'
  }]
}, {
  featureType: 'poi.attraction',
  stylers: [{
    visibility: 'off'
  }]
}, {
  featureType: 'poi.business',
  stylers: [{
    visibility: 'off'
  }]
}, {
  featureType: 'poi.government',
  elementType: 'labels.icon',
  stylers: [{
    visibility: 'off'
  }]
}, {
  featureType: 'poi.medical',
  elementType: 'labels.icon',
  stylers: [{
    visibility: 'off'
  }]
}, {
  featureType: 'poi.medical',
  elementType: 'labels.text',
  stylers: [{
    visibility: 'on'
  }]
}, {
  featureType: 'poi.park',
  elementType: 'labels',
  stylers: [{
    visibility: 'on'
  }]
}, {
  featureType: 'poi.place_of_worship',
  elementType: 'labels.icon',
  stylers: [{
    visibility: 'off'
  }]
}, {
  featureType: 'poi.school',
  elementType: 'labels.icon',
  stylers: [{
    visibility: 'off'
  }]
}, {
  featureType: 'poi.sports_complex',
  elementType: 'labels.icon',
  stylers: [{
    visibility: 'off'
  }]
}, {
  featureType: 'transit',
  elementType: 'labels.text',
  stylers: [{
    visibility: 'off'
  }]
}];
var _default = DEFAULT_MAP_STYLES;
exports.default = _default;